
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";
import { useSignalR } from "@/composables/useSignalR";

const { deviceCount, startConnection, stopConnection } = useSignalR();

@Component({
  name: "Dashboard"
})
export default class Dashboard extends Vue {
  deviceCount = deviceCount;

  private drawer = true;
  private title = "پاور باکس";
  private fixed = false;

  getNotif() {
    this.$router.push("/device-notifications");
  }

  // متد بررسی پرمیشن
  checkPermission(permission: string) {
    if (!permission) return true;

    const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");

    // دسترسی کامل
    if (permissions.includes("System.All")) return true;

    // دسترسی مستقیم
    return permissions.includes(permission);
  }

  private items = [
    {
      icon: "mdi-home",
      title: "صفحه اصلی",
      to: "/home",
      permission: "Home_Show"
    },
    {
      icon: "mdi-account",
      title: "مدیریت کاربران",
      to: "/users",
      permission: "Member_List"
    },
    {
      icon: "mdi-domain",
      title: "مجموعه ها",
      to: "/complexes",
      permission: "Complex_Show"
    },
    {
      icon: "mdi-monitor-eye",
      title: "پایش سلامت دستگاه‌ها",
      to: "/device-logs",
      permission: "DeviceLog_ViewAll",
      notify: true
    },
    {
      icon: "mdi-cog",
      title: "تنظیمات مجموعه",
      to: "/complex-settings",
      permission: "LocationType_View",
      extra: "LocationGrade_View"
    },
    {
      icon: "mdi-cog-outline",
      title: "تنظیمات دستگاه",
      to: "/device-settings",
      permission: "DeviceType_View"
    },
    {
      icon: "mdi-account-key",
      title: "نقش‌ها",
      to: "/complex-roles",
      permission: "ComplexRole_Show"
    },
    {
      icon: "mdi-newspaper-variant-outline",
      title: "گزارش بازدید فنی",
      to: "/reports",
      permission: "Reports_List"
    },
    {
      icon: "mdi-account-check",
      title: "حضور و غیاب",
      to: "/attendance",
      permission: "Attendance_Show"
    },
    {
      icon: "mdi-card-text",
      title: "متن اعلان‌ها",
      to: "/notifications",
      permission: "Notification_List"
    },
    // {
    //   icon: "mdi-bell-ring",
    //   title: "اعلان‌ها",
    //   to: "/device-notifications",
    //   permission: "NotificationLog_List"
    // },
    {
      icon: "mdi-message-text",
      title: "گزارش پیام‌های دستگاه‌ها",
      to: "/devices-sms-list",
      permission: "DeviceSms_List"
    },
    {
      icon: "mdi-gamepad-variant",
      title: "پیام‌های بازی",
      to: "/game-sms",
      permission: "GameSms_List"
    },
    {
      icon: "mdi-package-variant-closed",
      title: "نسخه‌های دستگاه",
      to: "/device-ota",
      permission: "OtaList_Show"
    },
    {
      icon: "mdi-lifebuoy",
      title: "پشتیبانی",
      to: "/support",
      permission: "Support_List"
    },
    {
      icon: "mdi-shield-account-outline",
      title: "تصویر امنیتی",
      to: "/security-image",
      permission: "SecurityImage_Show"
    },
    {
      icon: "mdi-chart-arc",
      title: "گزارش استفاده",
      to: "/hourse-charge-filter",
      permission: "Chart_Show"
    },
    {
      icon: "mdi-file-excel",
      title: "گزارش اکسل",
      to: "/excel-export",
      permission: "Reports_Export"
    },
    {
      icon: "mdi-file-excel-outline",
      title: "اکسل استفاده از دستگاه",
      to: "/excel-device-usage",
      permission: "DeviceUsage_Excel"
    },
    {
      icon: "mdi-file-code",
      title: "گزارش درخواست های ازدست رفته",
      to: "/missed-requests",
      permission: "Missed_Requests"
    },
    {
      icon: "mdi-math-log",
      title: "لاگ کاربران",
      to: "/member-logs",
      permission: "Log_Show"
    },
    {
      icon: "mdi-chart-line",
      title: "آمارها",
      permission: "Chart_Show",
      items: [
        {
          icon: "",
          title: "استفاده کابل شارژ",
          to: "/chart-charge",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "انتخاب عکس امنیتی",
          to: "/chart-pic-pass",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "پر استفاده ترین دستگاه",
          to: "/chart-device-uses",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "امتیاز کاربران",
          to: "/chart-rate",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "ساعات استفاده",
          to: "/chart-user-hours",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "اپراتورهای تلفن همراه",
          to: "/chart-operator",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "استان‌ها",
          to: "/chart-provinces",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "پراکندگی کاربران یکتا",
          to: "/per-unique-user-per-day-per-terminal",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "پراکندگی کاربران",
          to: "/per-user-per-day-per-terminal",
          permission: "Chart_Show"
        },
        {
          icon: "",
          title: "پراکندگی ساعات شارژ",
          to: "/charge-duration",
          permission: "Chart_Show"
        }
      ]
    },
    {
      icon: "mdi-account-edit",
      title: "پروفایل",
      to: "/profile",
      permission: "Profile_Show"
    }
  ];

  get currentUser() {
    return UserModule.fullName;
  }

  private logout = () => {
    UserModule.ResetToken();
    localStorage.removeItem("permissions");
    location.reload();
  };

  mounted() {
    startConnection();
  }

  beforeDestroy() {
    stopConnection();
  }
}
